import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(public)/i/$id')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/invoice/$id', params: { id: params.id }, replace: true });
  },
  component: () => null,
});
